import React from 'react';
import styles from './Features.module.scss';

const AttendeeTab = () => (
  <div>
    <div className={styles.FeaturesTab}>
      <div className={styles.Container}>
        <h2>Payments made fast and easy.</h2>
        <p>
          Borrowed cash from a friend during an event & need to pay them back?
          Bounce has you covered with our direct payments.
        </p>
        <div className={styles.SectionHeadline}>
          <div style={{ position: 'relative' }}>
            <img
              style={{ width: '250px' }}
              src="/img/illustrations/landing/send-payment.png"
              alt="Send Payment"
            />
            <div>
              <img
                className={styles.PaymentList}
                src="/img/illustrations/landing/payment-list.png"
                alt="Payment List"
              />
            </div>
          </div>

          <div className={styles.Description}>
            <h2>Send and Receive Money</h2>
            <p>
              Drinks? Rent? Groceries? Bounce your friends back for any borrowed
              money in 3 quick taps.
            </p>
          </div>
        </div>
        <div className={styles.SectionHeadlineReverse}>
          <img
            src="/img/illustrations/landing/secure-payment.png"
            alt="Secure Payment"
          />
          <div className={styles.Description}>
            <h2>Secure Payments</h2>
            <p>
              PCI compliant and encrypted with AES-256, all your sensitive data
              is secured and protected when operating with Bounce.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div className={styles.P2PContainer}>
      <div className={styles.Container}>
        <h2>With Bounce, it’s easy to make direct payments to friends.</h2>
        <div className={styles.Transaction}>
          <p>
            Send between $5 - $1000 per transfer. Your first $1000 each month
            are free 💰
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default AttendeeTab;
